var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_348_489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8252 0.671143C5.74212 0.671143 0 6.41326 0 13.4964C0 19.5109 4.14101 24.5579 9.72718 25.944V17.4158H7.08261V13.4964H9.72718V11.8076C9.72718 7.44236 11.7028 5.41905 15.9885 5.41905C16.8011 5.41905 18.2031 5.57859 18.7767 5.73763V9.29022C18.474 9.25841 17.9482 9.24251 17.2951 9.24251C15.1923 9.24251 14.3797 10.0392 14.3797 12.1102V13.4964H18.5689L17.8491 17.4158H14.3797V26.2277C20.7302 25.4608 25.651 20.0537 25.651 13.4964C25.6505 6.41326 19.9084 0.671143 12.8252 0.671143Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_348_489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.6505,
    height: 25.6505,
    fill: "white",
    transform: "translate(0 0.671143)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.bbc965006a416eadcb470bbe57fd609d.svg";
export { ForwardRef as ReactComponent };